import { Box, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { AggregatorSelect } from "../../components/AggregatorSelect";
import { AnalyticsLinearGraph } from "./components/Graph";
import { SelectGraph } from "./components/SelectGraph";
import { GraphSummary } from "./components/Summary";
import { DownloadExcel } from "../../components/DownloadExcel";
import { useQuery } from "react-query";
import { subDays } from "date-fns";
import { useSelector } from "react-redux";
import {
  selectCurrentLocation,
  selectCurrentRestaurantGroupId,
} from "@src/store/app_manager/selector";
import { fetchAnalyticsGraphRepo } from "./data/repository/OrderGraphRepo";
import { NoGraphComponent } from "./components/NoGraphComponent";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export const OrderGraph: React.FC = () => {
  const weekBeforeDate = subDays(new Date(), 13);

  const onPeriodSelected = (start: Date, end: Date) => {
    setStartPeriod(dayjs(start).utc().toISOString());
    setEndPeriod(dayjs(end).utc().toISOString());
  };

  const selectedLocation = useSelector(selectCurrentLocation);
  const currentGroup = useSelector(selectCurrentRestaurantGroupId);

  const [startPeriod, setStartPeriod] = React.useState<string>(
    dayjs(weekBeforeDate).utc().toISOString()
  );
  const [endPeriod, setEndPeriod] = React.useState<string>(
    dayjs(subDays(new Date(), 6)).utc().toISOString()
  );

  const onGraphSelected = (graph: string) => {
    setSelectedGraph(graph);
  };

  const onDownloadPressed = () => {};

  const onAggregatorSelected = (aggregators: string[]) => {
    setSelectedAggregators(aggregators);
  };

  const [selectedAggregators, setSelectedAggregators] = React.useState([
    "wolt",
  ]);

  const [selectedGraph, setSelectedGraph] = React.useState("");

  const { data, status } = useQuery({
    queryKey: ["by-date", selectedLocation, startPeriod, endPeriod],

    queryFn: () =>
      fetchAnalyticsGraphRepo.execute({
        startDate: startPeriod,
        endDate: endPeriod,
        restaurantId: selectedLocation === "all" ? "" : selectedLocation,
        groupId: currentGroup,
      }),
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (status === "success" && selectedGraph === "") {
      setSelectedGraph(data.graphs[0]);
    }
  }, [status]);

  return (
    <Box marginTop={"100px"} marginBottom={"100px"}>
      <AggregatorSelect
        title="Заказы через"
        availableAggregators={["wolt", "glovo", "yandex", "all"]}
        selectedAggregators={selectedAggregators}
        onAggregatorSelected={onAggregatorSelected}
        onPeriodSelected={onPeriodSelected}
        isMultiSelect={true}
      />

      {status === "loading" && (
        <Box alignItems={"center"} display={"flex"} flexDirection={"column"}>
          <CircularProgress />
        </Box>
      )}
      {status === "error" && <Box />}
      {status === "success" &&
        (selectedGraph !== "" && data.config[selectedGraph].graph.length > 0 ? (
          <Box>
            <AnalyticsLinearGraph
              selectedAggregators={selectedAggregators}
              data={data.config[selectedGraph].graph}
              toolTipTitle={data.config[selectedGraph].toolTipTitle}
            />
            <SelectGraph
              onGraphSelected={onGraphSelected}
              selectedGraph={selectedGraph}
              graphs={data.graphs}
              config={data.config}
            />
            <GraphSummary
              summaryLabel={data.config[selectedGraph].label}
              summaryValue={data.config[selectedGraph].value}
            />

            {data.downloadUrl !== undefined && (
              <DownloadExcel
                onDownloadPressed={onDownloadPressed}
                file={data.downloadUrl}
              />
            )}
          </Box>
        ) : (
          <Box display={"flex"} justifyContent={"center"} marginTop={"70px"}>
            <NoGraphComponent />
          </Box>
        ))}
    </Box>
  );
};